/** 从计费项 relation.config 解析数量单位 quantityUnit */
export function parseQuantityUnitFromBillConfig(config?: unknown): string | undefined {
  if (config == null || config === '') return undefined;
  try {
    const parsed = typeof config === 'string' ? JSON.parse(String(config)) : config;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return undefined;
    const unit = (parsed as { quantityUnit?: unknown }).quantityUnit;
    const text = unit != null ? String(unit).trim() : '';
    return text || undefined;
  } catch {
    return undefined;
  }
}
